import Navbar from '../components/Navbar/Navbar'
import Labs from '../components/Labs/Labs'
import LabProducts from '../components/LabProducts/LabProducts'
import Footer from '../components/Footer/Footer'


const Lab = () => {
    return(
        <>
            <Navbar />
            <main className='lab'>
                <h1>Laboratorio</h1>
            </main>
            <Labs />
            <LabProducts />
            <Footer />
        </>
    )
}

export default Lab